
module.exports = {
    storeBoomeaJwtParams(action, jwt, context) {
        action.meetingType = jwt.meeting_type;
        action.audioType = jwt.audio_type;
        action.modAudioType = jwt.mod_audio_type;
        action.modCode = jwt.mod_code;
        action.redirectUrl = jwt.redirect_url;
        action.boomeauser = context.user;
    },

    _user2participant({ avatar, avatarUrl, email, id, name, boomea_team_id, boomea_user_id, caller_id_name, caller_id_number, audiopin, sipaudio }) {
        const participant = {};

        if (typeof avatarUrl === 'string') {
            participant.avatarURL = avatarUrl.trim();
        } else if (typeof avatar === 'string') {
            participant.avatarURL = avatar.trim();
        }
        if (typeof email === 'string') {
            participant.email = email.trim();
        }
        if (typeof id === 'string') {
            participant.id = id.trim();
        }
        if (typeof name === 'string') {
            participant.name = name.trim();
        }
        if (typeof boomea_team_id === 'string') {
            participant.boomea_team_id = boomea_team_id.trim();
        }
        if (typeof boomea_user_id === 'string') {
            participant.boomea_user_id = boomea_user_id.trim();
        }
        if (typeof caller_id_name === 'string') {
            participant.caller_id_name = caller_id_name.trim();
        }
        if (typeof caller_id_number === 'string') {
            participant.caller_id_number = caller_id_number.trim();
        }
        if (typeof audiopin === 'string') {
            participant.audiopin = audiopin.trim();
        }
        if (typeof sipaudio === 'string') {
            participant.sipaudio = sipaudio.trim();
        }


        return Object.keys(participant).length ? participant : undefined;
    }
};